
import { MdOutlineMoreHoriz } from "react-icons/md";
import { useDispatch } from "react-redux";
import styled from "styled-components";
import { handleActiveSelect } from "../../features/layout/layoutSlice";
import { useSelector } from "react-redux";
import { deleteAIChatQuestion, getAiQuestionItemData } from "../../features/aiControl/aiControlSlice";
import textBoldMaker from "../../helper/textBoldMaker";
import { showModal } from "../../features/modal/modalSlice";

const Container = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    background-color: ${({theme}) => theme.secondaryBgColor};
    padding: 20px 15px;
    border-radius: 10px;

    
    .question-top{
        width: 100%;
        display: flex;
        justify-content: space-between;
        margin-bottom: 10px;

        .question{
            font-size: var(--font-size-sm);
            font-weight: var(--font-weight-xl);
        }
        
        .control-container{
            display: flex;
            align-items: center;
            gap: 10px;
            position: relative;

            .question-status{
                width: 10px;
                height: 10px;
                border-radius: 50%;
                background-color: ${({isActive}) => isActive ? "var(--color-green)" : "var(--color-main)"};
            }

            .more-icon{
                font-size: 1.4rem;
                fill: ${({theme}) => theme.mainTextColor};
                cursor: pointer;
            }

            .more-container{
                position: absolute;
                top: 20px;
                right: -15px;
                width: 100px;
                height: auto;
                background-color: ${({theme}) => theme.mainBgColor};
                border: 1px solid ${({theme}) => theme.mainBorderColor};
                border-radius: 10px;
                display: flex;
                flex-direction: column;
                overflow: hidden;

                .more-item{
                    padding: 8px 0 8px 10px;
                    font-size: var(--font-size-sm);
                    font-weight: var(--font-weight-md);
                    border-bottom: 2px solid ${({theme}) => theme.secondaryBgColor};
                    cursor: pointer;

                    &:hover{
                        background-color: var(--color-main);
                        color: #fff;
                    }
                }
            }

        }
    }

    .question-answer{
        width: 100%;
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-md);
        line-height: 24px;
    }

    .bold{
        font-weight: var(--font-weight-xl);
    }

`


//! bu gösterirken kullanılan
const QuestionItemRead = ({messageItem}) => {

    const dispatch = useDispatch() 
    const {activeSelect} = useSelector(state => state.layout)
    // dangerouslySetInnerHTML={{ __html: textBoldMaker(item.terms) }}
    
  return (
    <Container isActive={messageItem.isActive}>
        <div className="question-top">
            <p className="question" dangerouslySetInnerHTML={{ __html: messageItem.question?.replace(/\n/g, "<br>") }}></p>
            <div className="control-container">
                <div className="question-status"/>
                <MdOutlineMoreHoriz className="more-icon" onClick={(e)=> {e.stopPropagation(); dispatch(handleActiveSelect((activeSelect && activeSelect === `AIQuestionMore${messageItem.id}`) ? null : `AIQuestionMore${messageItem.id}`))}}/>
                {
                    activeSelect === `AIQuestionMore${messageItem.id}` &&
                    <div className="more-container">
                        <div className="more-item" onClick={() => {dispatch(showModal("updateAiSingleQuestionItem")); dispatch(getAiQuestionItemData(messageItem))}}>Düzenle</div>
                        <div className="more-item" onClick={() => dispatch(deleteAIChatQuestion(messageItem.id))}>Soruyu Sil</div>
                    </div>
                }
            </div>
        </div>
        <p className="question-answer"dangerouslySetInnerHTML={{ __html: textBoldMaker(messageItem?.answer)?.replace(/\n/g, "<br>")}}></p>
    </Container>
  )
}

export default QuestionItemRead